<template>
  <main id="content">
    <section class="pt-4 pb-4">
      <b-container fluid>
        <b-row>
          <b-col md="2">
            <DashboardNav />
          </b-col>
          <b-col md="10">
            <b-card no-body>
              <b-tabs card>
                <b-tab title="My Jobs" active>
                  <b-card-text>
                    <div class="card card-body">
                      <div
                        v-if="loadingJob"
                        class="p-5 d-flex justify-content-center text-muted w-100"
                      >
                        <font-awesome-icon icon="sync" size="2x" spin />
                      </div>
                      <div v-else-if="job">
                        <b-row class="mb-2">
                          <b-col>
                            <b-button
                              :to="
                                '/settings/jobs/' +
                                  this.$route.params.id +
                                  '/jobs'
                              "
                              variant="secondary"
                              class="mr-2 mt-minus no-margin"
                            >
                              <font-awesome-icon icon="arrow-left" />
                            </b-button>
                            <span style="font-size:20px;">{{
                              job.jobTitle
                            }}</span>
                          </b-col>
                          <b-col>
                            <b-button-group class="float-right">
                              <b-btn
                                variant="secondary"
                                v-b-tooltip.hover
                                title="Export KML File"
                                @click="get_kml_link()"
                              >
                                <font-awesome-icon icon="cloud-download-alt" />
                              </b-btn>
                              <b-modal
                                size="lg"
                                ok-only
                                v-model="showKMLModel"
                                title="Export KML File"
                                ok-title="Close"
                              >
                                <div v-if="loadingJob">
                                  <font-awesome-icon
                                    icon="sync"
                                    size="2x"
                                    spin
                                  />
                                </div>
                                <div v-else>
                                  <span class="title">URL:- &nbsp; </span>
                                  <textarea
                                    v-model="kml_url"
                                    class="form-control"
                                    disabled
                                  >
                                  </textarea>
                                  <!-- <span class="code text-red">{{ kml_url }}</span> -->
                                  <br />
                                  <span
                                    class="btn btn-info text-white copy-btn ml-auto"
                                    @click.stop.prevent="copyTestingCode"
                                  >
                                    Copy
                                  </span>
                                </div>
                                <input
                                  type="hidden"
                                  id="kml_url_file"
                                  :value="kml_url"
                                />
                              </b-modal>
                              <b-btn
                                v-b-modal.addUser
                                variant="secondary"
                                v-b-tooltip.hover
                                title="Share with social media"
                              >
                                <i
                                  class="fa fa-share-alt ml-2"
                                  icon="sync"
                                  spin
                                ></i>
                              </b-btn>
                              <b-modal
                                ok-only
                                ref="addUser"
                                id="addUser"
                                title="Share Job"
                                ok-title="Close"
                              >
                                <p style="font-size:16px">
                                  Click To Any Social Link And Share with your
                                  Friend
                                </p>
                                <span class="box-share">
                                  <email
                                    :url="url"
                                    :subject="subject"
                                    :body="body"
                                    scale="3"
                                  ></email>
                                </span>
                                <span class="box-share">
                                  <facebook :url="body" scale="3"></facebook>
                                </span>
                                <span class="box-share">
                                  <linkedin :url="body" scale="3"></linkedin>
                                </span>
                                <span class="box-share">
                                  <whats-app
                                    :url="body"
                                    title="Hello"
                                    scale="3"
                                  ></whats-app>
                                </span>
                              </b-modal>
                              <b-btn
                                @click="downloadReport"
                                v-b-tooltip.hover
                                title="Download PDF File"
                              >
                                <i class="fa fa-download"></i>
                                <font-awesome-icon
                                  v-if="downloadingReport"
                                  class="ml-2"
                                  icon="sync"
                                  spin
                                />
                              </b-btn>
                              <b-btn
                                @click="printReport"
                                v-b-tooltip.hover
                                title="Job Print"
                              >
                                <font-awesome-icon icon="print" />
                                <font-awesome-icon
                                  v-if="printingReport"
                                  class="ml-2"
                                  icon="sync"
                                  spin
                                />
                              </b-btn>
                            </b-button-group>
                          </b-col>
                        </b-row>
                        <div>
                          <strong>Created At:</strong>
                          {{
                            new Date(
                              job.jobCreationTime * 1000
                            ).toLocaleDateString("en-us", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit"
                            })
                          }}
                        </div>
                        <div>
                          <strong>Description:</strong>
                          {{ job.jobDescription }}
                        </div>
                        <div>
                          <gmap-map
                            ref="map_ref"
                            class="dashboard-map rounded shadow"
                            map-type-id="satellite"
                            :center="map_center"
                            :zoom="map_zoom"
                            @center_changed="
                              new_center => {
                                currentMapCenter = new_center.toJSON();
                              }
                            "
                            @zoom_changed="
                              new_zoom => {
                                currentMapZoom = new_zoom;
                              }
                            "
                            :options="mapStyle"
                          >
                            <gmap-marker
                              v-for="m in mapMarkers"
                              :key="`mark-${m.markerKey}`"
                              :position="m.markerLatLng"
                              :clickable="true"
                              :draggable="false"
                              :icon="getMarkerIcon(m)"
                              @click="openInfoWindowTemplate(m)"
                            />
                            <gmap-info-window
                              :options="asBuiltMarkerInfoOptions"
                              :position="infoWindow.position"
                              :opened="infoWindow.open"
                              @closeclick="infoWindow.open = false"
                            >
                              <div v-html="infoWindow.template"></div>
                            </gmap-info-window>
                            <gmap-polyline
                              v-for="p in mapPolylines"
                              :key="`poly-${p.polylineKey}`"
                              :path="p.polylinePath"
                              :options="getPolylineOptions(p)"
                              :deepWatch="true"
                              @click="selectedPolyline = p"
                            />
                            <gmap-polyline
                              v-for="p in mapdrawing"
                              :key="`draw-${p.markerKey}`"
                              :options="{
                                strokeColor: p.markerColor,
                                strokeOpacity: 1,
                                strokeWeight: isSelected ? 4 : 2
                              }"
                              :path="p.markerLatLng"
                              :deepWatch="true"
                            />
                          </gmap-map>
                        </div>
                      </div>

                      <div v-else class="text-center pt-4 pb-3 text-muted">
                        <div class="d-flex justify-content-center mb-3">
                          <font-awesome-icon
                            icon="exclamation-triangle"
                            size="3x"
                          />
                        </div>
                        <div class="h5">
                          {{
                            loadingError ? "Error loading job" : "Invalid job"
                          }}
                        </div>
                      </div>
                    </div>
                    <b-row class="my-3">
                      <b-col>
                        <div
                          class="dashboard-plot rounded shadow"
                          ref="plot_ref"
                        ></div>
                      </b-col>
                    </b-row>
                    <div class="card card-body" v-if="selectedPolyline">
                      <h2 class="h4 mb-3">Line Info</h2>
                      <div>
                        <strong>Status</strong><br />
                        {{
                          selectedPolyline.polylineStatus
                            ? "Completed"
                            : "Pending"
                        }}
                      </div>
                    </div>
                    <div class="card card-body">
                      <div>
                        <h2 class="h4">All Marker Info</h2>
                        <div class="col-md-12">
                          <table
                            class="table table-bordered table-striped table-responsive"
                            style="table-layout:fixed;"
                            width="100%"
                          >
                            <thead class="thead-dark" data-aos="fade-down">
                              <tr>
                                <th width="2%" data-aos="fade-right">S.No.</th>
                                <th width="15%" data-aos="fade-right">
                                  Lat-long
                                </th>
                                <th width="15%" data-aos="fade-right">
                                  Created At
                                </th>
                                <th width="15%" data-aos="fade-right">
                                  Created By
                                </th>
                                <th width="16%" data-aos="fade-right">
                                  Description
                                </th>
                                <th width="10%" data-aos="fade-right">
                                  Bar Code
                                </th>
                                <th width="27%" data-aos="fade-right">
                                  Others Fields
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(MarkerFields, index2) in mapMarkers"
                                :key="`allfield-${MarkerFields.markerKey}`"
                                data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-duration="500"
                              >
                                <td style="vertical-align: top;">
                                  <strong>{{ index2 + 1 }}</strong>
                                </td>
                                <td style="vertical-align: top;">
                                  {{ MarkerFields.lat.toPrecision(6) }} ,
                                  {{ MarkerFields.lng.toPrecision(6) }}
                                </td>
                                <td style="vertical-align: top;">
                                  {{
                                    new Date(
                                      MarkerFields.createdTime * 1000
                                    ).toLocaleDateString("en-us", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit"
                                    })
                                  }}
                                </td>
                                <td style="vertical-align: top;">
                                  {{ get_username(job.uid) }}
                                </td>
                                <td style="vertical-align: top;">
                                  <span v-if="MarkerFields.notes">
                                    <span
                                      v-if="MarkerFields.notes.length > 100"
                                    >
                                      {{ give_less_text(MarkerFields.notes) }}
                                      <!-- {{ MarkerFields.notes }} -->
                                      <span @click="readmore" class="u_links">
                                        <span v-if="check_less_text">
                                          read more..
                                        </span>
                                        <span v-else>
                                          read less..
                                        </span>
                                      </span>
                                    </span>
                                    <span v-else>
                                      {{ MarkerFields.notes }}
                                    </span>
                                  </span>
                                  <span v-else> Not Found </span>
                                </td>
                                <td style="vertical-align: top;">
                                  <span v-if="MarkerFields.qrBarCode">
                                    {{ MarkerFields.qrBarCode }}
                                  </span>
                                  <span v-else>
                                    Not Found
                                  </span>
                                </td>
                                <td
                                  v-if="MarkerFields.fields != null"
                                  style="vertical-align: top;"
                                >
                                  <div class="panel-group">
                                    <div class="panel">
                                      <div
                                        class="panel-heading"
                                        style="margin-bottom:10px;"
                                      >
                                        <a
                                          data-toggle="collapse"
                                          :href="'#' + MarkerFields.markerKey"
                                          class="btn btn-primary btn-sm"
                                          >View Fields</a
                                        >
                                        <br />
                                      </div>
                                      <div
                                        :id="MarkerFields.markerKey"
                                        class="panel-collapse collapse"
                                      >
                                        <div class="panel-body">
                                          <table class="table table-striped">
                                            <thead
                                              style="background-color:#00A8FF; color:#fff; font-weight:bold"
                                            >
                                              <td>S.No.</td>
                                              <td>Fields Name</td>
                                              <td>Fields Data</td>
                                              <td>Unit Type</td>
                                            </thead>
                                            <tbody>
                                              <tr
                                                v-for="(fields,
                                                index) in MarkerFields.fields"
                                                :key="`field-${index}`"
                                              >
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ fields.fieldName }}</td>
                                                <td>{{ fields.fieldData }}</td>
                                                <td>
                                                  {{ fields.fieldUnitType }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td v-else style="vertical-align: top;">
                                  No Fields
                                </td>
                              </tr>

                              <!-- {{ fields.fieldName }} :- {{fields.fieldData}} -->
                            </tbody>
                          </table>
                          <!-- {{ selectedMarker.fields }} -->
                        </div>
                        <div v-if="mapimages.length > 0">
                          <strong>All Images</strong><br />
                          <span
                            v-for="mapimage in mapimages"
                            :key="mapimage.imgKey"
                            :v-if="`mapimage.path.a = '2'`"
                            style="maring:15px"
                          >
                            <a :href="mapimage.path.i" target="_blank">
                              <b-img-lazy
                                thumbnail
                                class="pothole-image"
                                :src="mapimage.path.i"
                                data-aos="flip-down"
                                data-aos-duration="3000"
                              >
                              </b-img-lazy>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Invoicing">
                  <Finence />
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import Email from "../components/Email";
import Facebook from "../components/Facebook";
import Linkedin from "../components/LinkedIn";
import WhatsApp from "../components/Whatsapp";
import firebase from "firebase";
import DashboardNav from "../components/DashboardNav.vue";
import Finence from "./JobFinence.vue";
import { db, JobExportKmlLink } from "../modules/database";
import { gmapApi } from "vue2-google-maps";
import constants from "../modules/constants";
import {
  isNullOrUndefined,
  isArray,
  isUndefined,
  isString,
  isBoolean,
  isNumber
} from "util";
const Plotly = require("plotly.js/dist/plotly-gl3d.min");

const selectedMarkerPath =
  "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0";
const unselectedMarkerPath =
  "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z";

export default {
  data() {
    return {
      kml_url: "",
      loadingKML: false,
      showKMLModel: false,
      job: null,
      check_less_text: true,
      //info
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: ""
      },
      asBuiltMarkerInfoOptions: {
        pixelOffset: {
          width: 0,
          height: -40
        }
      },
      fullpath: "",
      fetchingDetails: false,
      selectedimages: {
        0: {
          path: []
        }
      },
      mapMarkers: [],
      selectedMarker: null,
      mapPolylines: [],
      mapdrawing: [],
      mapimages: [],
      mapfields: [],
      isSelected: "",
      selectedPolyline: null,
      loadingJob: false,
      map_center: { lat: 47.6, lng: -122.31 },
      map_zoom: 14,
      currentMapCenter: null,
      currentMapZoom: null,
      loadingError: false,
      map_object: null,
      mapStyle: {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUI: true,
        styles: [
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ opacity: 0.35 }] }
        ]
      },
      newUser: {
        email: ""
      },
      // url:
      //   "https://drillmapslocal.firebaseapp.com//settings/job/sub_FfAXNbITHiUa6g/-Lr-pnZr4qki6_156kSM",
      url: this.$route.query.page,
      subject: "Job Shared",
      body:
        "Hello I'am Sharing a job Look and let me know anythnik (for access create account or login if have) www.drillmaps.com" +
        this.$route.path +
        " Click Here",
      downloadingReport: false,
      printingReport: false,
      pdfDocDef: null,
      waypointMarkerInfoPos: null,
      waypointMarkerInfoOpen: false,
      waypointCurrentMarkerInfoidx: null,
      waypointMarkers: [],
      waypointMarkerInfoOptions: {
        pixelOffset: {
          width: 0,
          height: -40
        }
      },
      wayPointIcon: {
        url: constants.markerFilters.plan.imageUrl
      },
      imageHeight: 400,
      imageWidth: 800,
      users: {},
      //plotly from here
      plotlyData: [],
      plotlyConfig: {
        scrollZoom: true,
        showLink: false,
        // modeBarButtonsToRemove: [
        //   "toImage",
        //   "zoom2d",
        //   "pan",
        //   "pan2d",
        //   "autoScale2d"
        // ],
        displayLogo: false,
        displayModeBar: false
      },
      plotlyLayout: {
        title: "Map Plot",
        showlegend: false,
        autosize: true,
        scene: {
          camera: {
            eye: {
              x: -4.212918255580453,
              y: 1.216805840022677,
              z: 2.721568092408052
            },
            up: {
              z: 1
            }
          },
          aspectmode: "data",
          xaxis: {
            type: "linear",
            zeroline: false,
            title: "Longitude"
          },
          yaxis: {
            type: "linear",
            zeroline: false,
            title: "Latitude"
          },
          zaxis: {
            type: "linear",
            zeroline: false,
            title: "Depth"
          }
        }
      }
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.srn = 1;
  },
  methods: {
    get_kml_link() {
      this.loadingKML = true;
      JobExportKmlLink(this.$route.params.s_id, this.$route.params.id)
        .then(response => {
          console.log(response);
          this.kml_url = response;
        })
        .catch(() => {
          console.log("error");
        })
        .finally(() => {
          this.showKMLModel = true;
          this.loadingKML = false;
          this.copyTestingCode();
        });
    },
    copyTestingCode() {
      let testingCodeToCopy = document.querySelector("#kml_url_file");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        this.$root.toast("URL copied " + msg);
      } catch (err) {
        alert("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    get_username(u_id) {
      let full_name = "Demo";
      if (u_id != null) {
        if (typeof this.users[u_id] != "undefined") {
          full_name = this.users[u_id].UserFullName;
        }
        // full_name = this.users.u_id.UserFullName;
      }
      return full_name;
    },
    readmore() {
      if (this.check_less_text) {
        this.check_less_text = false;
      } else {
        this.check_less_text = true;
      }
    },
    give_less_text(text) {
      let value = "";
      if (this.check_less_text) {
        value = text.slice(0, 100);
      } else {
        value = text;
      }
      return value;
    },
    addUser: function() {
      this.user.push({ name: "", email: "" });
    },
    deleteUser: function(index) {
      console.log(index);
      console.log(this.finds);
      this.user.splice(index, 1);
      if (index === 0) this.addUser();
    },
    updateTotal(event) {
      this.fee_total = event.target.value;
    },
    getimageurl(img) {
      // var imageKey = Object.keys(this.selectedMarker.drillImages);
      // var img = this.selectedMarker.drillImages[imageKey[0]];
      var storage = firebase.storage();
      var full = storage.ref(img).getDownloadURL();
      var now_url = full.i;
      return now_url;
    },
    opentab(url) {
      window.open(url, "_blank");
    },
    openInfoWindowTemplate(item) {
      this.selectedMarker = item;
      this.infoWindow.open = true;
      //notes start
      var notes = "";
      if (this.selectedMarker.notes) {
        notes = this.selectedMarker.notes;
      } else {
        notes = "Not Found";
      }
      var lat = this.selectedMarker.markerLatLng.lat;
      var lng = this.selectedMarker.markerLatLng.lng;
      var latstr = lat.toPrecision(6);
      var lngstr = lng.toPrecision(6);
      var latlng = latstr + " , " + lngstr;
      //notes end
      //field

      this.infoWindow.position = this.selectedMarker.markerLatLng;
      this.infoWindow.template =
        '<div style="width:250px; height:100px"><h6>Marker Details</h6><p>' +
        "<b>Description :- " +
        notes +
        "</b></p><p>LatLng:- " +
        latlng +
        " </p></div>";
    },
    isUndefined(value) {
      return isUndefined(value);
    },
    setupFirebaseReading() {
      this.loadingJob = true;
      this.$rtdbBind(
        "job",
        db.ref("jobs/" + this.$route.params.id).child(this.$route.params.s_id)
      );
      this.$rtdbBind("users", db.ref("users"))
        .then(() => {
          this.loadingJob = false;
          this.$nextTick(() => {
            this.setupMap();
            this.populatePlotlyData();
            Plotly.newPlot(
              this.$refs.plot_ref,
              this.plotlyData,
              this.plotlyLayout,
              this.plotlyConfig
            );
          });
        })
        .catch(error => {
          this.loadingJob = false;
          console.log(error);
          this.loadingError = true;
        });
    },
    getMarkerIcon(marker) {
      let isSelected =
        this.selectedMarker !== null &&
        this.selectedMarker.markerKey === marker.markerKey;
      var markerColor = "";
      if (marker.markerColor == "#FFFFFF00") {
        markerColor = "#EB1C24";
      } else {
        markerColor = marker.markerColor;
      }
      return {
        path: isSelected ? selectedMarkerPath : unselectedMarkerPath,
        fillColor: markerColor,
        fillOpacity: 1,
        strokeColor: "#000",
        strokeWeight: 2,
        scale: 1
      };
    },
    getPolylineOptions(polyline) {
      let isSelected =
        this.selectedPolyline !== null &&
        this.selectedPolyline.polylineKey === polyline.polylineKey;

      return {
        geodesic: true,
        strokeColor: polyline.polylineColor,
        strokeOpacity: 1,
        strokeWeight: isSelected ? 4 : 2
      };
    },
    setupMap() {
      this.$refs.map_ref.$mapPromise.then(map => {
        this.map_object = map;
        // this.selectedMarker =
        //   this.mapMarkers.length === 0 ? null : this.mapMarkers[0];
        // this.selectedPolyline =
        //   this.mapPolylines.length === 0 ? null : this.mapPolylines[0];
        this.adjustMapJobDisplay();
      });
    },
    adjustMapJobDisplay() {
      if (this.map_object !== null) {
        let newSelectedMarker = null;
        let newSelectedPolyline = null;

        let newBounds = new this.google.maps.LatLngBounds();
        for (const marker of this.mapMarkers) {
          newBounds.extend(marker.markerLatLng);
          if (
            this.selectedMarker !== null &&
            newSelectedMarker === null &&
            this.selectedMarker.markerKey === marker.markerKey
          ) {
            newSelectedMarker = marker;
          }
        }
        //adjust map to new bounds
        if (!newBounds.isEmpty()) {
          this.map_object.fitBounds(newBounds, {
            //padding
            bottom: 20,
            left: 20,
            right: 20,
            top: 20
          });
        }

        for (const polyline of this.mapPolylines) {
          if (
            this.selectedPolyline !== null &&
            newSelectedPolyline === null &&
            this.selectedPolyline.polylineKey === polyline.polylineKey
          ) {
            newSelectedPolyline = polyline;
          }
        }

        this.selectedMarker = newSelectedMarker;
        this.selectedPolyline = newSelectedPolyline;
      }
    },
    isValidDrill(testDrill) {
      let error = false;
      if (testDrill === undefined) {
        error = true;
      } else if (
        !(
          isBoolean(testDrill.status) &&
          isString(testDrill.lineColor) &&
          isNumber(testDrill.createdTime) &&
          (isArray(testDrill.coordinates) ||
            isNullOrUndefined(testDrill.coordinates))
        )
      ) {
        error = true;
        console.log("error parsing drill");
        console.dir(testDrill);
      }
      return !error;
    },
    isValidCoordinate(testCoordinate) {
      let error = false;
      if (testCoordinate === undefined) {
        error = true;
      } else if (
        !(
          isNumber(testCoordinate.lat) &&
          isNumber(testCoordinate.lng) &&
          isNumber(testCoordinate.createdTime)
        )
      ) {
        error = true;
        console.log("error parsing coordinate");
        console.dir(testCoordinate);
      }
      return !error;
    },
    isValidJob(testJob) {
      let error = false;
      if (testJob === undefined) {
        error = true;
      } else if (
        !(
          isNumber(testJob.jobCreationTime) &&
          isString(testJob.jobDescription) &&
          isString(testJob.jobTitle) &&
          isString(testJob.uid)
        )
      ) {
        error = true;
        console.log("error parsing job");
        console.dir(testJob);
      }
      return !error;
    },
    parseMapJob(job) {
      try {
        if (job === null) return [[], []];
        if (!this.isValidJob(job)) return [[], []];

        //return list of all polylines to display in map from job object
        //properties needed for markers are
        //polylineKey(c), polylinePath(c), polylineColor(c), polylineStatus(c)
        //c = computed, d = from database
        let parsedPolylines = [];

        //return list of all markers to display in map from job object
        //properties needed for markers are
        //markerKey(c), markerLatLng(c), markerColor(c), notes(d), images(d), createdAt(d)
        //c = computed, d = from database
        let parsedMarkers = [];

        //check if drills are not undefined
        if (isNullOrUndefined(job.drills)) return [[], []];

        for (const drillKey of Object.keys(job.drills)) {
          const drill = job.drills[drillKey];
          if (!this.isValidDrill(drill)) continue;
          //check if coordinates are not undefined or empty
          if (
            isNullOrUndefined(drill.coordinates) ||
            !isArray(drill.coordinates) ||
            drill.coordinates.length <= 0
          )
            continue;

          let coordinateKey;
          let currPolylinePath = [];

          for (
            coordinateKey = 0;
            coordinateKey < drill.coordinates.length;
            coordinateKey++
          ) {
            const coordinate = drill.coordinates[coordinateKey];
            if (!this.isValidCoordinate(coordinate)) continue;
            //todo should add auto generated coordinate key
            let currMarkerKey = drillKey + "_" + coordinateKey + "_map";
            let currMarkerLatLng = {
              lat: coordinate.lat,
              lng: coordinate.lng
            };
            parsedMarkers.push({
              ...coordinate,
              markerKey: currMarkerKey,
              markerLatLng: currMarkerLatLng,
              markerColor: drill.lineColor
            });
            currPolylinePath.push(currMarkerLatLng);

            parsedPolylines.push({
              polylineKey: currMarkerKey,
              lat: coordinate.lat,
              lng: coordinate.lng,
              polylinePath: currPolylinePath,
              polylineColor: drill.lineColor,
              polylineStatus: drill.status
            });
          }

          // if (currPolylinePath.length <= 0) continue;
        }

        return [
          parsedMarkers.length === 0 ? [] : parsedMarkers,
          parsedPolylines.length === 0 ? [] : parsedPolylines
        ];
      } catch (error) {
        this.loadingError = true;
      }
    },
    parseMapimages(job) {
      try {
        if (job === null) return [[], []];
        if (!this.isValidJob(job)) return [[], []];

        //return list of all polylines to display in map from job object
        //properties needed for markers are
        //polylineKey(c), polylinePath(c), polylineColor(c), polylineStatus(c)
        //c = computed, d = from database
        let parsedimages = [];
        let parsedfields = [];

        //return list of all markers to display in map from job object
        //properties needed for markers are
        //markerKey(c), markerLatLng(c), markerColor(c), notes(d), images(d), createdAt(d)
        //c = computed, d = from database
        // let parsedField = [];

        //check if drills are not undefined
        if (isNullOrUndefined(job.drills)) return [[], []];

        for (const drillKey of Object.keys(job.drills)) {
          const drill = job.drills[drillKey];
          if (!this.isValidDrill(drill)) continue;
          //check if coordinates are not undefined or empty
          if (
            isNullOrUndefined(drill.coordinates) ||
            !isArray(drill.coordinates) ||
            drill.coordinates.length <= 0
          )
            continue;

          let coordinateKey;
          for (
            coordinateKey = 0;
            coordinateKey < drill.coordinates.length;
            coordinateKey++
          ) {
            const coordinate = drill.coordinates[coordinateKey];
            if (!this.isValidCoordinate(coordinate)) continue;
            //todo should add auto generated coordinate key
            let currimageKey = drillKey + "_" + coordinateKey + "_img";
            if (coordinate.drillImages) {
              for (const imgkey of Object.keys(coordinate.drillImages)) {
                let img_url = coordinate.drillImages[imgkey];
                var storage = firebase.storage();
                var full_url = storage.ref(img_url).getDownloadURL();
                parsedimages.push({
                  path: full_url,
                  imgkey: currimageKey
                });
              }
            }
            if (coordinate.fields) {
              for (
                let field_key = 0;
                field_key < coordinate.fields.length;
                field_key++
              ) {
                const fields = coordinate.fields[field_key];
                parsedfields.push({
                  ...fields,
                  filedkey: currimageKey
                });
              }
            }
          }
        }

        return [
          parsedimages.length === 0 ? [] : parsedimages,
          parsedfields.length === 0 ? [] : parsedfields
        ];
      } catch (error) {
        this.loadingError = true;
      }
    },
    parseMapdrawing(job) {
      try {
        if (job === null) return [[], []];
        if (!this.isValidJob(job)) return [[], []];

        //return list of all Drawings to display in map from job object
        //properties needed for markers are
        //DrawingKey(c), DrawingPath(c), Drawinguser(c), polylineisDelete(c)
        //c = computed, d = from database
        let parsedDrawing = [];

        //check if drills are not undefined
        if (isNullOrUndefined(job.drills)) return [[], []];

        for (const drillKey of Object.keys(job.drills)) {
          const drill = job.drills[drillKey];
          if (!this.isValidDrill(drill)) continue;
          //check if coordinates are not undefined or empty
          if (
            isNullOrUndefined(drill.DrawingCoordinates) ||
            !isArray(drill.DrawingCoordinates) ||
            drill.DrawingCoordinates.length <= 0
          )
            continue;

          let drawingKey;

          for (
            drawingKey = 0;
            drawingKey < drill.DrawingCoordinates.length;
            drawingKey++
          ) {
            const Drawings = drill.DrawingCoordinates[drawingKey];
            //todo should add auto generated coordinate key
            let currDrwaingKey = drillKey + "_" + drawingKey + "_draw";
            // let currMarkerLatLng = {
            //   lat: coordinate.lat,
            //   lng: coordinate.lng
            // };
            let currDrawingLatLng = Drawings.Drawing;
            if (Drawings.isDeleted != true) {
              parsedDrawing.push({
                // ...Drawings,
                markerKey: currDrwaingKey,
                markerLatLng: currDrawingLatLng,
                markerisDelete: Drawings.isDeleted,
                markerColor: Drawings.DrawingColor
              });
            }
          }
        }
        return [parsedDrawing.length === 0 ? [] : parsedDrawing];
      } catch (error) {
        this.loadingError = true;
      }
    },
    buildReport: async function() {
      //await image url to data url
      // let mapDataUri = await this.buildStaticMapDataUri();
      let plotDataUri = await Plotly.toImage(this.$refs.plot_ref, {
        format: "png",
        width: this.imageWidth,
        height: this.imageHeight
      });
      let waypointTableContent = this.buildWaypointTableContent();
      // let mapimg = this.buildimages();
      this.pdfDocDef = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [20, 30, 20, 30],
        footer: function(currentPage, pageCount) {
          return [
            {
              text: `${currentPage} of ${pageCount}`,
              alignment: "center"
            }
          ];
        },
        content: [
          {
            text: this.job.jobTitle,
            style: ["header", "center"]
          },
          // { text: "Map", style: ["subHeader"] },
          // {
          //   width: this.imageWidth,
          //   height: this.imageHeight,
          //   image: mapDataUri,
          //   pageBreak: "after"
          // },
          { text: "Map Plotly", style: ["subHeader"] },
          {
            width: this.imageWidth,
            height: this.imageHeight,
            image: plotDataUri,
            pageBreak: "after"
          },
          // { text: "Jobs", style: ["subHeader"] },
          { text: "Markers Details", style: ["subHeader"] },
          {
            table: {
              headerRows: 1,
              widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto"],
              body: waypointTableContent
            }
            // pageBreak: "after"
          }
        ],
        styles: {
          header: {
            fontSize: 22,
            bold: true
          },
          subHeader: {
            fontSize: 15,
            bold: true
          },
          center: {
            alignment: "center"
          }
        }
      };
    },
    downloadReport: function() {
      if (!this.loadingData) {
        this.downloadingReport = true;
        //create jspdf here
        this.buildReport().then(() => {
          this.downloadingReport = false;
          pdfMake.createPdf(this.pdfDocDef).download();
        });
      }
    },
    printReport: function() {
      if (!this.loadingData) {
        this.printingReport = true;
        //create jspdf here
        this.buildReport().then(() => {
          this.printingReport = false;
          pdfMake.createPdf(this.pdfDocDef).print();
        });
      }
    },
    // buildimages: function() {
    //   let imgurl = "";
    //   for (const image in this.mapimages) {
    //     {
    //       imgurl = imgurl + "images:" + this.mapimages[image]["path"]["i"];
    //     }
    //   }
    //   return imgurl;
    // },
    buildStaticMapDataUri: function() {
      return new Promise((resolve, reject) => {
        //parameters for static link
        // const center =
        //   this.currentMapCenter.lat.toString() +
        //   "," +
        //   this.currentMapCenter.lng.toString();
        // const zoom = this.currentMapZoom;
        const size = this.imageWidth + "x" + this.imageHeight;

        const scale = 2; //scale affects map quality

        // marker from here
        // let waypointMarkersString = "&markers=size:small|color:blue";
        // for (let index = 0; index < this.mapMarkers.length; index++) {
        //   waypointMarkersString =
        //     waypointMarkersString +
        //     "|" +
        //     this.mapMarkers[index].lat +
        //     "," +
        //     this.mapMarkers[index].lng;
        // }

        // polyline from here

        var path = "";
        let waypointMarkersString = "";
        for (const polyObj in this.mapPolylines) {
          let color = this.mapPolylines[polyObj]["polylineColor"];
          let LineColor = color.substr(1);

          waypointMarkersString = "&markers=size:small|color:0x" + LineColor;
          for (let index = 0; index < this.mapMarkers.length; index++) {
            waypointMarkersString =
              waypointMarkersString +
              "|" +
              this.mapMarkers[index].lat +
              "," +
              this.mapMarkers[index].lng;
          }
          path += "&path=color:0x" + LineColor + "|weight:2";
          for (const polyArray in this.mapPolylines[polyObj]["polylinePath"]) {
            path +=
              "|" +
              this.mapPolylines[polyObj]["polylinePath"][polyArray]["lat"] +
              "," +
              this.mapPolylines[polyObj]["polylinePath"][polyArray]["lng"];
          }
        }
        const baseUrl = constants.urls.gMapsStaticBase;
        const key = constants.api_keys.googlemaps;
        let gMapsStaticUrl = baseUrl;
        // gMapsStaticUrl += "?center=" + center;
        // gMapsStaticUrl += "&zoom=" + zoom;
        gMapsStaticUrl += "?size=" + size;
        gMapsStaticUrl += "&scale=" + scale;
        gMapsStaticUrl += "&maptype=" + "satellite";
        gMapsStaticUrl += waypointMarkersString;
        gMapsStaticUrl += path;
        // gMapsStaticUrl += "&path=" + asBuiltpolylinesString;
        gMapsStaticUrl += "&key=" + key;

        console.log("built static map link: " + gMapsStaticUrl);

        fetch(gMapsStaticUrl)
          .then(r => {
            return r.blob();
          })
          .then(blob => {
            const reader = new FileReader();
            reader.addEventListener(
              "load",
              function() {
                resolve(reader.result);
              },
              false
            );
            reader.readAsDataURL(blob);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    buildWaypointTableContent() {
      //body: [
      //    [ 'First', 'Second', 'Third', 'The last one' ],
      //    [ 'Value 1', 'Value 2', 'Value 3', 'Value 4' ],
      //    [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
      //  ]
      let wTableContent = [];

      //push headers first

      wTableContent.push([
        "#",
        "S.No.",
        "Created At",
        "Created By",
        "Description",
        "Bar Code",
        "Others Fields"
      ]);
      let index = 0;
      for (let wDataRow of this.mapMarkers) {
        let currDataRow = [];
        currDataRow.push(index);
        currDataRow.push(
          wDataRow.lat.toPrecision(6) + "," + wDataRow.lng.toPrecision(6)
        );
        currDataRow.push(
          new Date(wDataRow.createdTime * 1000).toLocaleDateString("en-us", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          })
        );
        currDataRow.push(this.get_username(this.job.uid));
        if (wDataRow.notes) {
          currDataRow.push(wDataRow.notes);
        } else {
          currDataRow.push("Not Found");
        }
        if (wDataRow.qrBarCode) {
          currDataRow.push(wDataRow.qrBarCode);
        } else {
          currDataRow.push("Not Found");
        }
        if (wDataRow.fields != null) {
          let filed_exp = 1;
          let feild_body_new = [];
          feild_body_new.push([
            "S.No.",
            "Fields Name",
            "Fields Data",
            "Unit Type"
          ]);
          let filed_inner = [
            {
              table: {
                body: feild_body_new
              }
            }
          ];
          for (let inside_field of wDataRow.fields) {
            let filed_polyline = [];
            filed_polyline.push(filed_exp);
            filed_polyline.push(inside_field.fieldName);
            filed_polyline.push(inside_field.fieldData);
            filed_polyline.push(inside_field.fieldUnitType);
            feild_body_new.push(filed_polyline);
            filed_exp++;
          }
          currDataRow.push(filed_inner);
          feild_body_new = [];
        } else {
          currDataRow.push("Not Found");
        }
        wTableContent.push(currDataRow);
        index++;
      }
      return wTableContent;
    },
    populatePlotlyData: function() {
      let rodwiseDetails = this.job.drills;
      // let waypointDetails = this.mapfields;

      this.plotlyData = this.plotify(rodwiseDetails);
    },
    plotify: function(rodwiseDetails) {
      const polylinelistObj = [];

      for (const drillKey of Object.keys(rodwiseDetails)) {
        const drill = rodwiseDetails[drillKey];
        let coordinateKey;
        let lat;
        let lng;
        let prevX = 0;
        let prevY = 0;
        let prevLat = 0;
        let prevLng = 0;
        let hexlineColor = drill.lineColor;
        let asBuiltLatArr = [];
        let asBuiltLngArr = [];
        let asBuiltDepthArr = [];
        let asBuiltMode = "line+marker";
        if (drill.lineColor == "#FFFFFF00") {
          asBuiltMode = "markers";
        }
        if (drill.coordinates.length == 0) {
          asBuiltMode = "markers";
        }
        let lineColor = this.covertlinecolor(hexlineColor);
        for (
          coordinateKey = 0;
          coordinateKey < drill.coordinates.length;
          coordinateKey++
        ) {
          const coordinate = drill.coordinates[coordinateKey];
          if (typeof coordinate != "undefined") {
            lat = coordinate.lat;
            lng = coordinate.lng;
            let depthPer1000 = 0;
            asBuiltDepthArr.push(-depthPer1000);
            if (coordinateKey == 0) {
              asBuiltLatArr.push(0);
              asBuiltLngArr.push(0);
            } else {
              let distX = GetDistanceX(prevLat, prevLng, lat, lng);
              let distY = GetDistanceY(prevLat, prevLng, lat, lng);
              distX += prevX;
              distY += prevY;
              asBuiltLatArr.push(distX);
              asBuiltLngArr.push(distY);
              prevX = distX;
              prevY = distY;
            }
            prevLat = lat;
            prevLng = lng;
          }
        }
        let singlePolyline = {
          color: lineColor,
          x: asBuiltLngArr,
          y: asBuiltLatArr,
          z: asBuiltDepthArr,
          hoverinfo: "text",
          mode: asBuiltMode,
          line: {
            //green
            color: lineColor,
            width: 10
          },
          type: "scatter3d",
          showscale: false
        };
        polylinelistObj.push(singlePolyline);
      }
      // console.log(polylinelistObj)
      return polylinelistObj;
    },
    covertlinecolor(fullhex) {
      let hex = fullhex.slice(1);
      let bigint = parseInt(hex, 16);
      let r = (bigint >> 16) & 255;
      let g = (bigint >> 8) & 255;
      let b = bigint & 255;
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    refreshPlotly() {
      this.populatePlotlyData();
      Plotly.react(
        this.$refs.plot_ref,
        this.plotlyData,
        this.plotlyLayout,
        this.plotlyConfig
      );
    }
  },
  watch: {
    job(newJob) {
      if (newJob === null) {
        //reset display
        this.mapMarkers = [];
        this.selectedMarker = null;
        this.mapPolylines = [];
        this.selectedPolyline = null;
        this.mapimages = [];
      } else {
        [this.mapMarkers, this.mapPolylines] = this.parseMapJob(newJob);
        [this.mapdrawing] = this.parseMapdrawing(newJob);
        [this.mapimages, this.mapfields] = this.parseMapimages(newJob);
        this.adjustMapJobDisplay();
      }
    }
  },
  computed: {
    google: gmapApi,
    ...mapGetters({
      user: "getUser"
    })
  },

  components: {
    DashboardNav,
    Email,
    WhatsApp,
    Facebook,
    Linkedin,
    Finence
  }
};
function GetDistanceX(lat1, lng1, lat2, lng2) {
  var radlat1 = (Math.PI * lat1) / 180;
  var radlat2 = (Math.PI * lat2) / 180;
  // var radlng1 = (Math.PI * lng1) / 180; // I keep longitude same since I am calculating
  // var radlng2 = (Math.PI * lng1) / 180; // only X displacement
  var theta = lng1 - lng2;
  var radtheta = (Math.PI * theta) / 180;
  var dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist = dist * 1.609344; // this is the distance in Km
  dist = dist * 1000; // distance in meters

  return dist;
}

function GetDistanceY(lat1, lng1, lat2, lng2) {
  var radlat1 = (Math.PI * lat1) / 180; // I keep latitude same since I am calculating
  var radlat2 = (Math.PI * lat1) / 180; // only y displacement
  // var radlng1 = (Math.PI * lng1) / 180; // ask sir
  // var radlng2 = (Math.PI * lng2) / 180;
  var theta = lng1 - lng2;
  var radtheta = (Math.PI * theta) / 180;
  var dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist = dist * 1.609344; // this is the distance in Km
  dist = dist * 1000; // distance in meters
  return dist;
}
</script>

<style lang="scss" scoped>
.dashboard-map {
  width: 100%;
  height: 80vh;
  overflow: hidden;
}
.pothole-image {
  // max-width: 10vw;
  margin: 7px;
  height: 120px;
  width: 120px;
  object-fit: cover;
  object-position: center; /* Center the image within the element */
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // height: 100%;
  // width: auto;
  // -webkit-transform: translate(-50%, -50%);
  // -ms-transform: translate(-50%, -50%);
  // transform: translate(-50%, -50%);
}
.pothole-image + .pothole-image {
  margin-left: 1vw;
}
.avatar {
  height: 60px;
  border-radius: 100%;
}
p.user-role {
  text-transform: capitalize;
  width: 100%;
  text-align: center;
}
.box-share {
  padding: 10px;
}
.u_links {
  color: #00a8ff;
  cursor: -webkit-grab;
  cursor: grab;
}
.dashboard-map {
  width: 100%;
  height: 70vh;
  overflow: hidden;
}

// .map-control {
//   display: none;
// }
// /* Display the control once it is inside the map. */
// .dashboard-map .map-control {
//   display: block;
// }

.dashboard-plot {
  @extend .dashboard-map;
}
</style>
